/**
 * Zintegrowany handler dla Splide sliderów w Bricks Builder
 * Obsługuje Auto-Scroll i Variable Width
 */

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    updateEnhancedSliders();
  }, 10);
});

/**
 * Aktualizuje wszystkie enhanced slidery
 */
const updateEnhancedSliders = () => {
  const selector =
    '.brxe-slider-nested[data-auto-scroll-enable="true"], .brxe-slider-nested[data-variable-width-enable="true"], .brxe-slider-nested[data-clones]';

  document.querySelectorAll(selector).forEach((sliderElement) => {
    const sliderId = sliderElement.id.replace("brxe-", "");
    const splideInstance = window.bricksData?.splideInstances?.[sliderId];

    console.log(
      "DOMContentLoaded",
      window.bricksData?.splideInstances,
      splideInstance,
      sliderId,
      document.querySelectorAll(selector)
    );
    if (!splideInstance) return;

    const newOptions = prepareSliderOptions(
      sliderElement.dataset,
      splideInstance.options
    );
    splideInstance.destroy(true);
    let enhancedSlider = new Splide(`#${sliderElement.id}`, newOptions);
    enhancedSlider = enhancedSlider.mount(window.splide.Extensions);

    configureAdditionalBehaviors(enhancedSlider, sliderElement.dataset);
    window.bricksData.splideInstances[sliderId] = enhancedSlider;
  });
};

/**
 * Przygotowuje opcje dla slidera
 */
const prepareSliderOptions = (dataset, originalOptions) => {
  const options = { ...originalOptions };

  // Auto-scroll
  if (dataset.autoScrollEnable === "true") {
    const speed = parseFloat(dataset.autoScrollSpeed) || 1;
    const direction = dataset.autoScrollDirection || "ltr";
    const pauseOnHover = dataset.autoScrollPauseOnMouse !== "false"; // domyślnie true
    const rewind = dataset.autoScrollRewind !== "false"; // domyślnie true

    options.type = "loop";
    options.rewind = true;
    options.autoScroll = {
      speed,
      pauseOnHover,
      rewind,
    };

    if (!dataset.clones) {
      options.clones = 1;
    }

    // Ustaw kierunek przewijania
    options.direction = direction; // 'ltr', 'rtl', lub 'ttb'
  } else {
    // Wyłącz autoscroll explicite, ponieważ rozszerzenie włącza go domyślnie,
    // o ile nie ustawimy autoScroll na false.
    options.autoScroll = false;
  }

  // Variable width
  if (dataset.variableWidthEnable === "true") {
    options.autoWidth = true;
  }

  // Clones
  if (dataset.clones) {
    options.clones = parseInt(dataset.clones) || 1;
  }

  // Drag
  if (dataset.drag) {
    if (dataset.drag === "true") {
      options.drag = true;
    } else if (dataset.drag === "false") {
      options.drag = false;
    } else if (dataset.drag === "free") {
      options.drag = "free";
    }
  }

  return options;
};

/**
 * Konfiguruje dodatkowe zachowania slidera
 */
const configureAdditionalBehaviors = (splideInstance, dataset) => {
  // Przyspieszenie podczas scrollowania
  const hasAcceleration =
    dataset.autoScrollAccelerationOnScroll === "true" ||
    dataset["auto-scroll-acceleration-on-scroll"] === "true";

  if (hasAcceleration) {
    setTimeout(() => {
      configureScrollAcceleration(splideInstance, dataset);
    }, 1000); // Opóźnienie 1 sekundy
  }
};

/**
 * Konfiguruje przyspieszenie podczas scrollowania z płynnym easingiem
 */
const configureScrollAcceleration = (splideInstance, dataset) => {
  let scrollTimeout;
  let animationFrame;
  let isAnimating = false;

  let originalSpeed =
    parseFloat(dataset.autoScrollSpeed || dataset["auto-scroll-speed"]) || 1;
  originalSpeed = 2;
  const accelerationFactor = 4;
  const targetSpeed = originalSpeed * accelerationFactor;

  let currentSpeed = originalSpeed;

  const easeInOutQuart = (x) => 1 - Math.cos((x * Math.PI) / 2);

  const easeOutBack = (t) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
  };

  // Funkcja animacji prędkości z interpolacją
  const animateSpeed = (fromSpeed, toSpeed, duration, easingFn, callback) => {
    if (isAnimating) {
      cancelAnimationFrame(animationFrame);
    }

    isAnimating = true;
    const startTime = performance.now();
    const speedDifference = toSpeed - fromSpeed;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Zastosuj funkcję easing
      const easedProgress = easingFn(progress);

      // Interpolacja z subpixel precision
      currentSpeed = fromSpeed + speedDifference * easedProgress;

      // Aktualizuj prędkość tylko jeśli autoScroll jest aktywny
      if (splideInstance.options && splideInstance.options.autoScroll) {
        splideInstance.options = {
          ...splideInstance.options,
          autoScroll: {
            ...splideInstance.options.autoScroll,
            speed: currentSpeed,
          },
        };
      }

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        isAnimating = false;
        currentSpeed = toSpeed; // Ensure exact final value
        if (callback) callback();
      }
    };

    animationFrame = requestAnimationFrame(animate);
  };

  // Debounced scroll handler dla lepszej wydajności
  let scrollDebounceTimeout;
  let isScrolling = false;

  const handleScroll = () => {
    // Jeśli już się scrolluje, nie rozpoczynaj nowej animacji przyspieszenia
    if (!isScrolling) {
      isScrolling = true;
      // Płynne przyspieszenie z szybszą reakcją
      animateSpeed(currentSpeed, targetSpeed, 250, easeInOutQuart);
    }

    // Reset debounce timer
    clearTimeout(scrollDebounceTimeout);
    clearTimeout(scrollTimeout);

    scrollDebounceTimeout = setTimeout(() => {
      isScrolling = false;

      // Bardzo płynne przywracanie oryginalnej prędkości z eleganckim easing
      scrollTimeout = setTimeout(() => {
        animateSpeed(currentSpeed, originalSpeed, 100, easeOutBack);
      }, 150);
    }, 100);
  };

  // Użyj passive listener dla lepszej wydajności
  window.addEventListener("scroll", handleScroll, { passive: true });

  // Cleanup function
  return () => {
    window.removeEventListener("scroll", handleScroll);
    clearTimeout(scrollTimeout);
    clearTimeout(scrollDebounceTimeout);
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
  };
};

/**
 * API dla zewnętrznych wywołań
 */
window.BricksSliderEnhancer = {
  update: updateEnhancedSliders,

  updateSlider: (sliderId) => {
    if (document.getElementById(`brxe-${sliderId}`)) {
      updateEnhancedSliders();
    }
  },

  getInstance: (sliderId) => window.bricksData?.splideInstances?.[sliderId],
};
